export default "__VITE_ASSET__C$TJbsR1__"